module.exports = __webpack_public_path__ + "img/jumbo.6c3b379.png";